import React from 'react'

import styles from './MysteryBnnrNew.module.css'
import Image from 'next/image'
import { Button } from '@mui/material'

function MysteryBannerNew() {
  return (
    <>
      <div className={styles.mystery_banner_new_main}>
        
            <img src="/image/Mystery-shcool-new/mystery_school_logo_new.webp" alt="Mystery Banner"  className={styles.mystery_logo} />
      
        <div className={styles.banner_mystery_new}>
            <div className={styles.banner_mystery_new_txt}>
                <p><span>To learn more about the</span> </p>
                <h1><span>Mystery School</span></h1>
               <img src="/image/Mystery-shcool-new/glow_new.webp" alt="Mystery Banner"  className={styles.mystery_glow} />
            </div>
            <Button variant="contained" className={styles.mystery_btn} onClick={() => window.open('https://www.astrologypro.com/book/mystery-school', '_blank', 'noopener,noreferrer')}>Please click here to book a consultation.</Button>
        </div>
      </div>

      {/* <div className={styles.astrologypro_banner_new_main}>

         <img src="/image/Mystery-shcool-new/astropro_logo_new.webp" alt="Logo"  className={styles.astrologypro_bnnr_logo} />
        
        <div className={styles.astrologypro_bnnr_innr}>

          <p>To learn more about the </p>
          <h1><span>Mystery School</span></h1>

          <button>please click here to book a consultation.</button>

        </div>

       

      </div> */}
    </>
  )
}

export default MysteryBannerNew
